import Base from 'app/views/base';

import tmpl from 'templates/usps_rate_chart';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .dropdown.zone li a': 'setZone',
    'click .dropdown.type li a': 'setType',
  },

  initialize(options) {
    this.rateTables = options.rateTables;
    this.selectedZone = '1/2';
    this.selectedType = 'Parcel';
  },

  context() {
    const tables = this.rateTables;
    return {
      selectedZone: this.selectedZone,
      selectedType: this.selectedType,
      weights: tables.weights,
      subtypes: tables.subtypes[this.selectedType],
      data: tables.zoneData[this.selectedZone][this.selectedType],
      zones: tables.zones,
      types: tables.types,
    };
  },

  setZone(e) {
    e.preventDefault();
    this.selectedZone = String($(e.target).data('zone'));
    this.render();
  },

  setType(e) {
    e.preventDefault();
    this.selectedType = $(e.target).data('type');
    this.render();
  },
});



// WEBPACK FOOTER //
// ./app/views/usps_rate_chart_page.js